// extracted by mini-css-extract-plugin
export default {"faq":"Faq_faq__hMFXF","faq__container":"Faq_faq__container__uWfWW","faq__outlines":"Faq_faq__outlines__DtDRB","faq__outline":"Faq_faq__outline__1-0C9"};